import { useEffect, useState } from 'react';

import tokens from '@repo/tokens-studio/themes/light.json';

import { SplashLayout } from '@web/features/SplashScreen/SplashLayout';
import { ThemeDispatcher } from '@web/ui/theme/ThemeDispatcher';

import { SplashLogo } from './SplashLogo';

declare global {
  interface Window {
    splashScreenSkip?: boolean;
    splashScreenStop?: () => void;
    splashScreenPercentage?: number;
  }
}

let started = {
  time: typeof window === 'undefined' ? 0 : Date.now(),
  initialPercent: 0,
};

export const SplashScreen = () => {
  const [percent, setPercent] = useState(
    typeof window === 'undefined' ? 0 : (window.splashScreenPercentage ?? 0),
  );

  useEffect(() => {
    window.splashScreenStop?.();
    window.splashScreenSkip = true;
    started = {
      time: Date.now(),
      initialPercent: window.splashScreenPercentage ?? 0,
    };
    setPercent(started.initialPercent);

    let currentTimeout: ReturnType<typeof setTimeout>;

    function update() {
      if (!started.time) {
        return;
      }

      const computedPercent = Math.min(
        started.initialPercent + (Date.now() - started.time) / 3,
        100,
      );

      window.splashScreenPercentage = computedPercent;
      setPercent(computedPercent);
      if (computedPercent < 100) {
        currentTimeout = setTimeout(update, 10);
      }
    }
    currentTimeout = setTimeout(update, 10);

    return () => {
      clearTimeout(currentTimeout);
    };
  }, [setPercent]);

  return (
    <ThemeDispatcher theme={tokens}>
      <SplashLayout variant="dark">
        <SplashLogo width={150} loading={percent} />
      </SplashLayout>
      <script async src="/splash-screen.js" />
    </ThemeDispatcher>
  );
};
